<template>
  <div>
    <div class="contents admin">
      <SearchLine @search="search"></SearchLine>
      <div class="mt-xl-5">
        <table class="table board toggle-xxxl">
          <thead>
            <tr>
              <th class="col-auto">
                {{ $t("title.admin.game_no") }}
              </th>
              <!-- <th class="col-auto">{{ $t("title.common.location") }}</th> -->
              <!-- <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.admin.member_type") }}
              </th> -->
              <th class="col-auto">
                {{ $t("title.common.nickname") }}<br>
                ({{ $t("title.common.name") }})
              </th>

              <th class="col-auto d-none d-xxxl-table-cell">{{ $t("title.common.golfcourse") }}</th>
              <!-- <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.admin.holemode") }}
              </th> -->
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.common.hole") }}
              </th>
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.common.location") }}<br>
                ({{ $t("title.common.hittingbay") }})
              </th>
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.common.score") }}
              </th>
              <!-- <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.admin.player") }} <br>
                {{ $t("title.common.count") }}
              </th> -->
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.common.status") }}
              </th>
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.admin.start_time") }}
              </th>
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.admin.teebox") }} <br>
                ({{ $t("title.admin.wind") }})
              </th>
              <th class="col-auto d-none d-xxxl-table-cell">
                {{ $t("title.common.level") }} <br>
                ({{ $t("title.admin.mulligan") }})
              </th>
              <th class="col-auto d-none d-xl-table-cell">
                {{ $t("title.common.control") }}
              </th>
              <th class="th-arrow"></th>
            </tr>
          </thead>
          <tbody v-if="totalCnt">
            <template v-for="(item, idx) in items">
              <tr :key="idx + 't'">
                <td class="col-auto">
                  <span class="more" @click="search_gameno(item.gameno)">
                    {{ item.gameno }}
                  </span>
                </td>
                <!-- <td class="col-auto text-xxxl-start shop-name">
                  {{ item.shopname }}
                </td> -->
                <!-- <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.membertype | memtype }}
                </td> -->
                <td
                  class="col-auto"
                  v-if="item.playerno"
                >
                  <MemberInfo
                    :nickname="item.playernickname"
                    :playerno="item.playerno"
                    :displayText="item.playernickname"
                    :no_img="true"
                  />
                  <br>
                  ({{ item.playername }})
                </td>
                <td class="col-auto" v-else>
                  {{ item.gameplayername }}
                </td>
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.coursename }} <br>
                  {{ item.subcourseseqname1 ? item.subcourseseqname1 : "" }} 
                  {{ item.subcourseseqname1 && item.subcourseseqname2 ? "/" : "" }}
                  {{ item.subcourseseqname2 ? item.subcourseseqname2 : "" }}
                </td>
                <!-- <td
                  class="col-auto d-none d-xxxl-table-cell"
                  v-if="item.hole == 9"
                >
                  {{ item.subcourseseq == "1" ? "OUT" : "IN" }}

                  {{ item.hole }}H
                </td>
                <td class="col-auto d-none d-xxxl-table-cell" v-else>
                  {{ item.hole }}H
                </td> -->
                <td class="col-auto d-none d-xxxl-table-cell" v-if="item.holetype">
                  {{ item.finished_hole | suffix("H") }} /
                  {{ item.holetype | suffix("H") }}
                </td>        
                <td class="col-auto d-none d-xxxl-table-cell" v-else>                   
                  </td> 
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.shopname }}<br>
                  ({{ item.roomno }})
                </td>
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.shot == null ? "-" : item.shot }}
                </td>
                <!-- <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.cnt }}
                </td> -->
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.status | status3 }}
                </td>
                <td class="col-auto d-none d-xxxl-table-cell text-date">
                  {{ item.timezone_regdate | dateformat }}
                </td>
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.teebox | teeboxType }} <br>
                  ({{ item.wind | windType }})
                </td>
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.level | levelType }} <br>
                  ({{ item.mulligan == null ? "-" : item.mulligan }})
                </td>
                <!-- <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.wind | windType }}
                </td>
                <td class="col-auto d-none d-xxxl-table-cell">
                  {{ item.teebox | teeboxType }}
                </td> -->
                <td
                  class="col-auto d-none d-xl-table-cell w-1"
                  v-if="item.membertype == 1"
                >
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-xs d-block"
                    @click="goScoreboard(item.gameno)"
                  >
                    {{ $t("button.common.scoreboard") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary btn-xs d-block"
                    @click="goOneShotData(item.gameno)"
                  >
                    {{ $t("button.common.oneshot") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-xs d-block"
                    @click="goGameDataInfo(item.gameno)"
                  >
                    {{ $t("button.common.gamedata") }}
                  </button>
                </td>
                <td class="col-auto d-none d-xl-table-cell w-1" v-else>{{ item.membertype | memtype }}</td>
                <td class="td-arrow" @click="toggle_tr(idx)">
                  <img
                    src="/img/arrow_none_collapsed.png"
                    :class="{ 'btn-toggle-arrow': view_hide === idx }"
                  />
                </td>
              </tr>
              <tr
                class="d-xxxl-none"
                :class="{ show: view_hide === idx }"
                :key="idx + 'r'"
                v-if="view_hide === idx"
              >
                <td class="text-start" colspan="17">
                  <div class="toggle-content">
                    <!-- <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.game_no") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        <span class="more" @click="search_gameno(item.gameno)">
                          {{ item.gameno }}
                        </span>
                      </div>
                    </div> -->
                    <!-- <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.member_type") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.membertype | memtype }}
                      </div>
                    </div> -->
                    <!-- <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.nickname") }}<br />({{
                          $t("title.common.name")
                        }})
                      </div>
                      <div class="col-6 col-sm-8" v-if="item.playerno">
                        <MemberInfo
                          :nickname="item.playernickname"
                          :playerno="item.playerno"
                          :displayText="item.playernickname"
                          :no_img="true"
                        />({{ item.playername }})
                      </div>
                      <div class="col-6 col-sm-8" v-else>
                        {{ item.gameplayername }}
                      </div>
                    </div> -->

                    <!-- <div class="row" v-if="item.hole == 9">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.holemode") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.subcourseseq == "1" ? "OUT" : "IN" }}
                        {{ item.hole }}H
                      </div>
                    </div>
                    <div class="row" v-else>
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.holemode") }}
                      </div>
                      <div class="col-6 col-sm-8">{{ item.hole }}H</div>
                    </div> -->

                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.golfcourse") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.coursename }} <br>
                        {{ item.subcourseseqname1 ? item.subcourseseqname1 : "" }} 
                        {{ item.subcourseseqname1 && item.subcourseseqname2 ? "/" : "" }}
                        {{ item.subcourseseqname2 ? item.subcourseseqname2 : "" }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.hole") }}
                      </div>
                      <div class="col-6 col-sm-8"  v-if="item.holetype">
                        {{ item.finished_hole | suffix("H") }} /
                        {{ item.holetype | suffix("H") }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.hittingbay_no") }}
                      </div>
                      <div class="col-6 col-sm-8">{{ item.roomno }}</div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.score") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.shot == null ? "-" : item.shot }}
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.member_count") }}
                      </div>
                      <div class="col-6 col-sm-8">{{ item.cnt }}</div>
                    </div> -->
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.status") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.status | status3 }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.start_time") }}
                      </div>
                      <div class="col-6 col-sm-8 text-date">
                        {{ item.timezone_regdate | dateformat }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.mulligan") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.mulligan == null ? "-" : item.mulligan }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.level") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.level | levelType }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.wind") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.wind | windType }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.admin.teebox") }}
                      </div>
                      <div class="col-6 col-sm-8">
                        {{ item.teebox | teeboxType }}
                      </div>
                    </div>
                    <div class="row d-xl-none" v-if="item.membertype == 1">
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.control") }}
                      </div>
                      <div
                        class="col-6 col-sm-8 d-flex flex-column flex-sm-row"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-xs"
                          @click="goScoreboard(item.gameno)"
                        >
                          {{ $t("button.common.scoreboard") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary btn-xs my-1 my-sm-0 mx-0 mx-sm-1"
                          @click="goOneShotData(item.gameno)"
                        >
                          {{ $t("button.common.oneshot") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary btn-xs"
                          @click="goGameDataInfo(item.gameno)"
                        >
                          {{ $t("button.common.gamedata") }}
                        </button>
                      </div>
                    </div>
                    <div class="row d-xl-none" v-else>
                      <div class="col-6 col-sm-4">
                        {{ $t("title.common.control") }}
                      </div>
                      <div class="col-6 col-sm-8">{{ item.membertype | memtype }}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="17" class="text-center">
                {{ $t("text.common.no_data") }}
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination-nav
          :link-gen="linkGen"
          :number-of-pages="totalPage"
          v-model="searchData.pageno"
          v-if="totalPage > 1"
          use-router
          :aria-label="$t('text.common.pagination')"
          first-class="prev"
          prev-class="prev"
          next-class="next"
          last-class="next"
          hide-ellipsis
          limit="10"
        >
          <template #first-text
            ><i class="material-icons">keyboard_double_arrow_left</i></template
          >
          <template #prev-text
            ><i class="material-icons">navigate_before</i></template
          >
          <template #next-text
            ><i class="material-icons">navigate_next</i></template
          >
          <template #last-text
            ><i class="material-icons">keyboard_double_arrow_right</i></template
          >
          <template #page="{ page, active }">
            <div v-if="active">{{ page }}</div>
            <div v-else>{{ page }}</div>
          </template>
        </b-pagination-nav>
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import SearchLine from "./GameDataSearchLine";
import ax from "@/api/gamedata";

export default {
  name: "GameDataView",
  components: {
    SearchLine,
  },
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        starttime:
          this.$route.query.starttime ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].starttime) ||
          this.$dayjs().format("00:00"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        endtime:
          this.$route.query.endtime ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].endtime) ||
          this.$dayjs().format("23:59"),
        gameno:
          this.$route.query.gameno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].gameno) ||
          null,
        shopname:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].shopname) ||
          null,
        shopno:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].shopno) ||
          null,
        coursetype:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].coursetype) ||
          "", //C: course, D: driving range
        coursename:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].coursename) ||
          null,
        playername:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].playername) ||
          null,
        playernickname:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].playernickname) ||
          null,
        playerno:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].playerno) ||
          null,
        gamestatus0:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].gamestatus0) ||
          1, // 0,1
        gamestatus1:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].gamestatus1) ||
          null, // 0,1
        gamestatus2:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].gamestatus2) ||
          null, // 0,1
        gamestatus3:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].gamestatus3) ||
          null, // 0,1
        membertype:
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].membertype) ||
          0, // 0: 전체, 1: 손님, 2: 회원
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      rows: 10,
      totalCnt: 0,
      totalPage: 1,
      items: [],
      view_hide: null,
    };
  },

  watch: {
    "searchData.pageno": function () {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.getList();
    },
  },

  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      ax.gameDataList(this.searchData, (data) => {
        // console.log(this.searchData);
        // console.log(data);
        if (data) {
          this.items = data.gamelist;
          this.totalCnt = data.gamelistcnt;
          this.totalPage = Math.ceil(data.gamelistcnt / this.rows);
        } else {
          this.totalPage = 1;
          this.items = [];
        }
      });
    },
    search(params) {
      // console.log(params);
      this.searchData = params;
      this.searchData.pageno = 1;

      // this.$store.commit("setSearchData", {
      //   [this.$route.name]: 1,
      // });
      this.getList();
    },
    goScoreboard(gameno) {
      this.$router.push({
        name: "GameDataScoreBoard",
        query: {
          gameno: gameno,
          /*startdate: this.searchData.startdate,
          starttime: this.searchData.starttime,
          enddate: this.searchData.enddate,
          endtime: this.searchData.endtime,*/
        },
      });
    },
    goOneShotData(gameno) {
      this.$router.push({
        name: "GameDataOneShot",
        query: {
          gameno: gameno,
          /*startdate: this.searchData.startdate,
          starttime: this.searchData.starttime,
          enddate: this.searchData.enddate,
          endtime: this.searchData.endtime,*/
        },
      });
    },
    goGameDataInfo(gameno) {
      this.$router.push({
        name: "GameDataInfo",
        query: {
          gameno: gameno,
          /*startdate: this.searchData.startdate,
          starttime: this.searchData.starttime,
          enddate: this.searchData.enddate,
          endtime: this.searchData.endtime,*/
        },
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    search_gameno(gameno) {
      this.searchData.gameno = gameno;
      this.getList();
    },
  },
};
</script>
